"use client";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { PersonIcon } from "@radix-ui/react-icons";
import { LoginButton } from "./login-button";
import { getProviders } from "next-auth/react";
import { type ClientSafeProvider } from "node_modules/next-auth/lib/client";
import { useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";

export function LoginForm() {
  const [fetchingProvider, setFetchingProviders] = useState(true);
  const [providers, setProviders] = useState<Record<
    string,
    ClientSafeProvider
  > | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const res = await getProviders();
        setProviders(res);
      } catch (ex) {
        console.error(ex);
      } finally {
        setFetchingProviders(false);
      }
    })();
  }, []);

  return (
    <Card className="w-[350px]">
      <CardHeader className="flex items-center">
        <Avatar>
          <AvatarFallback>
            <PersonIcon />
          </AvatarFallback>
        </Avatar>
      </CardHeader>
      <CardContent>
        {fetchingProvider && (
          <div className="flex h-full w-full items-center justify-center">
            <LoaderCircle className="animate-spin" />
          </div>
        )}
        {!providers && !fetchingProvider && (
          <div>{"No authentication methods configured."}</div>
        )}
        {providers && !fetchingProvider && (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2">
            {Object.keys(providers).map((provider) =>
              providers[provider] ? (
                <LoginButton key={provider} provider={providers[provider]} />
              ) : null,
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
